module.exports = __webpack_public_path__ + "static/media/btn_apple_deu.54efa233.png";